module.exports = __webpack_public_path__ + "static/media/OIN-BUSD.45b792b5.svg";